export const Skeleton = {
  baseStyle: {
    borderRadius: '12px',
  },
}
